(function() {
  'use strict';

  /* ── Varianten ── */
  var pills     = document.querySelectorAll('.vbg-variant-pill');
  var priceEl   = document.getElementById('vbg-price');
  var compareEl = document.getElementById('vbg-compare-price');

  pills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      if (pill.disabled) return;
      pills.forEach(function(p) { p.classList.remove('active'); });
      pill.classList.add('active');
      document.querySelectorAll('.vbg-variant-input').forEach(function(i) {
        i.value = pill.dataset.variantId;
      });
      if (priceEl) priceEl.textContent = pill.dataset.price;
      if (compareEl) {
        if (pill.dataset.hasCompare === 'true') {
          compareEl.textContent = pill.dataset.compare;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    });
  });

  /* ── Menge ── */
  var qtyInput = document.getElementById('vbg-qty');
  var qtyMinus = document.getElementById('vbg-qty-minus');
  var qtyPlus  = document.getElementById('vbg-qty-plus');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10);
      if (v < 99) qtyInput.value = v + 1;
    });
    qtyInput.addEventListener('change', function() {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) qtyInput.value = 1;
      if (v > 99) qtyInput.value = 99;
    });
  }

  /* ── Add-to-Cart Loading State ── */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function() {
      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
      if (!btn.querySelector('.vbg-btn-text')) {
        btn.innerHTML = '<span class="vbg-btn-text">' + btn.innerHTML + '</span>';
      }
      setTimeout(function() {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }, 4000);
    });
  });

  /* ── FAQ ── */
  document.querySelectorAll('.vbg-faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item    = btn.parentElement;
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.vbg-faq-item').forEach(function(i) {
        i.classList.remove('open');
      });
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ── Reveal on Scroll ── */
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    document.querySelectorAll('.vbg-reveal, .vbg-reveal-left, .vbg-reveal-right').forEach(function(el) {
      el.classList.add('visible');
    });
  } else {
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.vbg-reveal, .vbg-reveal-left, .vbg-reveal-right').forEach(function(el) {
      revealObs.observe(el);
    });
  }

  /* ── Focus-Trap Helper ── */
  function trapFocus(container) {
    var focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    first.focus();

    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    container.addEventListener('keydown', handler);
    container._vbgTrapHandler = handler;
  }

  function releaseFocus(container) {
    if (container._vbgTrapHandler) {
      container.removeEventListener('keydown', container._vbgTrapHandler);
      delete container._vbgTrapHandler;
    }
  }

  /* ── Dosierungs-Spotlight ── */
  var overlay  = document.getElementById('vbg-dosage-overlay');
  var content  = document.getElementById('vbg-dosage-content');
  var closeBtn = document.getElementById('vbg-dosage-close');

  if (overlay && content) {
    document.querySelectorAll('[data-dosage]').forEach(function(card) {
      card.addEventListener('click', function() {
        /* Mobile: Accordion übernimmt — kein Overlay */
        if (window.innerWidth <= 600) return;
        content.innerHTML = card.innerHTML;
        overlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        trapFocus(overlay);
      });
    });
    function closeSpotlight() {
      releaseFocus(overlay);
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }
    if (closeBtn) closeBtn.addEventListener('click', closeSpotlight);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeSpotlight();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSpotlight();
    });
  }

  /* ── Kräuter Animation ── */
  function initIngaAnimation() {
    var herbs    = window.vbgIngaHerbs    || [];
    var cfg      = window.vbgIngaSettings || {};
    var featured = window.vbgIngaFeatured || '';
    var allIngs  = window.vbgIngaIngredients || '';
    var stage    = document.getElementById('vbgIngaStage');
    var bottle   = document.getElementById('vbgIngaBottle');
    var overlay  = document.getElementById('vbgIngaOverlay');
    var closeBtn = document.getElementById('vbgIngaClose');
    var grid     = document.getElementById('vbgIngaGrid');
    var titleEl  = document.getElementById('vbgIngaOverlayTitle');
    var subEl    = document.getElementById('vbgIngaOverlaySub');
    var hint     = document.getElementById('vbgIngaHint');

    if (!stage || !bottle || herbs.length === 0) return;

    var W  = stage.offsetWidth;
    var H  = stage.offsetHeight;
    var cx = W / 2;
    var cy = H / 2;
    var rx = Math.min(W, H) * 0.36;
    var ry = Math.min(W, H) * 0.30;

    /* SVG Linien-Layer */
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:1;';
    stage.insertBefore(svg, stage.firstChild);

    herbs.forEach(function(h, i) {
      var angle  = (i / herbs.length) * Math.PI * 2 - Math.PI / 2;
      var x      = cx + rx * Math.cos(angle);
      var y      = cy + ry * Math.sin(angle);
      var colors = (h.color || '#5a8a6a,#a8c5b0').split(',');
      var c1     = colors[0] || '#5a8a6a';
      var c2     = colors[1] || '#a8c5b0';

      /* SVG Linie */
      var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', cx); line.setAttribute('y1', cy);
      line.setAttribute('x2', x);  line.setAttribute('y2', y);
      line.setAttribute('stroke', c1);
      line.setAttribute('stroke-width', '1');
      line.setAttribute('stroke-opacity', '0.35');
      line.setAttribute('stroke-dasharray', '4 6');
      svg.appendChild(line);

      /* Karte */
      var card = document.createElement('div');
      card.className = 'vbg-inga-card';
      card.style.cssText = 'position:absolute; left:' + x + 'px; top:' + y + 'px; transform:translate(-50%,-50%); z-index:3; opacity:0;';
      card.innerHTML =
        '<div class="vbg-inga-card-inner" style="--c1:' + c1 + ';--c2:' + c2 + ';">' +
          '<div class="vbg-inga-badge">'        + (h.badge   || '')    + '</div>' +
          '<div class="vbg-inga-emoji">'         + (h.emoji   || '🌿') + '</div>' +
          '<div class="vbg-inga-herb-name">'    + (h.name    || '')    + '</div>' +
          '<div class="vbg-inga-herb-latin">'   + (h.latin   || '')    + '</div>' +
          '<div class="vbg-inga-herb-benefit">' + (h.benefit || '')    + '</div>' +
        '</div>';
      stage.appendChild(card);

      /* Karte einblenden */
      setTimeout(function() {
        if (window.gsap && !prefersReducedMotion) {
          gsap.to(card, { opacity: 1, scale: 1, duration: 0.5, ease: 'back.out(1.4)', delay: i * 0.1 });
        } else {
          card.style.opacity = '1';
        }
      }, 300 + i * 100);

      /* Klick auf Karte → fokussieren */
      card.addEventListener('click', function() {
        document.querySelectorAll('.vbg-inga-card').forEach(function(c) {
          c.classList.remove('focused');
        });
        card.classList.toggle('focused');
      });
    });

    /* Flasche anklicken → Overlay öffnen */
    bottle.style.cursor = 'pointer';
    bottle.addEventListener('click', function() {
      if (titleEl) titleEl.textContent = cfg.overlayTitle || '';
      if (subEl)   subEl.textContent   = cfg.overlaySub   || '';

      if (grid) {
        grid.innerHTML = '';
        var featArr = featured.split(',').map(function(s) { return s.trim(); });
        var allArr  = allIngs.split(',').map(function(s) { return s.trim(); });

        featArr.forEach(function(name) {
          if (!name) return;
          var el = document.createElement('div');
          el.className = 'vbg-inga-ing-item vbg-inga-ing-featured';
          el.textContent = name;
          grid.appendChild(el);
        });
        allArr.forEach(function(name) {
          if (!name) return;
          var el = document.createElement('div');
          el.className = 'vbg-inga-ing-item';
          el.textContent = name;
          grid.appendChild(el);
        });
      }

      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (hint) hint.style.opacity = '0';
      trapFocus(overlay);
    });

    /* Overlay schließen */
    function closeOverlay() {
      releaseFocus(overlay);
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      if (hint) hint.style.opacity = '1';
    }
    if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeOverlay();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeOverlay();
    });
  }

  /* Animation starten wenn GSAP geladen */
  if (document.getElementById('vbgIngaStage')) {
    if (window.gsap) {
      initIngaAnimation();
    } else {
      window.addEventListener('load', initIngaAnimation);
    }
  }
  /* ── Lightbox ── */
  var lb     = document.getElementById('vbg-lightbox');
  var lbImg  = document.getElementById('vbg-lightbox-img');
  var lbClose = document.getElementById('vbg-lightbox-close');

  if (lb && lbImg) {
    /* Event Delegation → funktioniert für alle Sections */
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('.vbg-lightbox-trigger');
      if (!trigger) return;
      lbImg.removeAttribute('width');
      lbImg.removeAttribute('height');
      lbImg.src = trigger.src;
      lbImg.alt = trigger.alt || '';
      lb.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });

    function closeLightbox() {
      lb.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    lb.addEventListener('click', function(e) {
      if (e.target === lb || e.target === lbImg) closeLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

})();
